module.exports = __webpack_public_path__ + "static/22_API-ecfff4b5fa0cf969c803e9c72d2aafd1.png";